import { Outlet } from 'react-router-dom';
import '../InboxLayout/InboxLayout.scss';
import { HTTPErrorAlertContainer } from 'br2s-ui-common-utils-02';

const CRMLayout = () => {
  return (
    <>
      <HTTPErrorAlertContainer className="http-inline-alert-container" />
      <Outlet />
    </>
  );
};

export default CRMLayout;
